<template>
    <section class="item clearfix panel panel-default bg-white bg-gradient b b-light">
        <div class="panel-body">
            <div class="row">
                <div class="col-sm-12 m-b">
                  <input type="text" v-model="data.name" name="awards[award_title][]" data-required="true" value="" class="form-control parsley-validated" placeholder="title of award*" data-maxlength="100">
                </div>
                <div class="col-sm-8 m-b">
                  <input type="text" v-model="data.organization" name="awards[award_organisation][]" value="" class="form-control" placeholder="awarded by" data-maxlength="100">
                </div>
                <div class="col-sm-4 m-b-md">
                  <datepicker 
                    v-model="data.date" 
                    :minimumView="'month'" 
                    :maximumView="'year'" 
                    :initialView="'year'" 
                    :required="true" 
                    class="form-control datepicker-input-month end-date-monthly" 
                    :placeholder="'date awarded*'"></datepicker>
                </div>
                <div class="col-sm-12 m-b">
                  <textarea rows="4" v-model="data.description" name="awards[award_description][]" class="form-control" style="resize: none" placeholder="description of award" spellcheck="false" data-gramm="false"></textarea>
                </div>
            </div>
        </div>
        <span class="pull-right btn btn-sm btn-light text-danger remove-item" @click="removeAward"><i class="fa fa-minus"></i> remove</span>
    </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker
  },
  props: [
    'index',
    'data'
  ],
  model: {
    prop: 'data',
    event: 'updateAward'
  },

  methods: {
    removeAward() {
      this.$emit('remove-award', this.index);
    }
  },
}
</script>

<style lang="scss">
  .vdp-datepicker input {
    border: none;
  }
</style>
